import { render } from "./AdvertisingImages.vue?vue&type=template&id=52788896&scoped=true"
import script from "./AdvertisingImages.vue?vue&type=script&lang=js"
export * from "./AdvertisingImages.vue?vue&type=script&lang=js"

import "./AdvertisingImages.vue?vue&type=style&index=0&id=52788896&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52788896"]])

export default __exports__